import React, { useEffect } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Store } from 'types/store';
import { MY_COVER, ROOT } from 'constants/routeConstants';
import useReferrerParam from 'hooks/useReferrerParam';
import mobileAppEvent from 'utils/reactNativeWebView';
import trackEvent from 'services/AnalyticsService';
import greatChoice from 'assets/images/loyaltyRewards/great-choice.gif';
import useCosmosTrackEvent from 'hooks/useCosmosTrackEvent';
import styles from './Confirmation.module.scss';
import UpgradeCrossSell from './UpgradeCrossSell';

const Confirmation: React.FC = () => {
  const pageModel = useSelector((state: Store) => state.journeys.loyaltyRewards.pageModel);
  const selectedReward = useSelector((state: Store) => state.journeys.loyaltyRewards.data.selectedReward);
  const claimResponse = useSelector((state: Store) => state.journeys.loyaltyRewards.claimResponse);
  const navigate = useNavigate();
  const isAppView = useReferrerParam();
  const { cosmosTrackEvent } = useCosmosTrackEvent('Loyalty Rewards');

  const duration = pageModel?.coverDuration !== 'Other'
    ? `the next ${pageModel?.coverDuration} months`
    : 'the next policy term';

  const finishBtnHandler = () => {
    if (isAppView) {
      mobileAppEvent('RLR_REDEEMED_CLOSE');
    } else {
      navigate(ROOT);
    }
  };

  const exploreBtnHandler = () => {
    cosmosTrackEvent('RLR_crosssell_clicked');
    mobileAppEvent('RLR_EXPLORE_UPGRADES_CLICKED');
    navigate(MY_COVER);
  };

  useEffect(() => {
    trackEvent('MyRAC_RLR_ConfirmationPage');
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (claimResponse?.isEligibleToExploreUpgrades) {
      cosmosTrackEvent('RLR_crosssell_displayed');
    }
  }, [claimResponse?.isEligibleToExploreUpgrades]);

  return (
    <>
      <div className={clsx(styles.confirmationImage, isAppView && styles.isAppViewConfirmationScreen)}>
        <img src={greatChoice} alt="Great choice" />
      </div>
      <div className={styles.confirmationParagraph}>
        <h4>You’re getting {selectedReward?.title} for {duration}</h4>
        <h4>What happens next?</h4>
        Your updated policy schedule will appear in myRAC within 5 working days.<br />
        Make sure to check your policy docs ahead of your renewal to make sure you’re happy with everything.
        We’ll update your renewal docs and your upgrade will kick in once your cover renews.
        {claimResponse?.isEligibleToExploreUpgrades && <UpgradeCrossSell onClose={finishBtnHandler} onExplore={exploreBtnHandler} />}
      </div>
      {!claimResponse?.isEligibleToExploreUpgrades && (
        <div className={styles.confirmationButtonWrapper}>
          <button onClick={finishBtnHandler} type="button">
            All done
          </button>
        </div>
      )}
    </>
  )
};

export default Confirmation;
